import React from "react";

function CancellationPolicy() {
  return <div>CancellationPolicy</div>;
}

export default CancellationPolicy;
